@if (filters().length > 0) {
  <div class="applied-filters">
    @for (filter of filters(); track filter.id) {
      <button
        type="button"
        class="applied-filter-chip"
        [attr.aria-label]="chipAriaLabel(filter)"
        (click)="onRemove(filter.id, $event)"
      >
        <span class="applied-filter-chip-label">{{ filter.label }}</span>
        <mat-icon class="applied-filter-chip-remove" aria-hidden="true">close</mat-icon>
      </button>
    }
    @if (showReset()) {
      <button type="button" class="applied-filter-reset" (click)="onReset()">
        {{ resetLabel() }}
      </button>
    }
  </div>
}
